export default __webpack_public_path__ + "static/media/arrow-small-left.42ae5d5a.svg";